import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2223c3dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timer-body" }

import { computed, onUnmounted, PropType, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SquareDotTimerWidget',
  props: {
  timer: {
    type: Object as PropType<{
      limit: number;
      remaining: number;
    }>,
    required: true
  }
},
  setup(__props) {

const props = __props



const dotCount = 56;
const dissabledDotIndexes = ref(new Set<number>());
const indexes = new Set<number>();
const lastRemainingTime = ref(0);

const dots = ref(
  Array.from({ length: dotCount }, () => {
    return { enabled: true };
  })
);

const time = computed(() => {
  const step = props.timer.remaining / props.timer.limit;

  const stepHealth = (step: number) => {
    if (step === 0) {
      return 'expired';
    } else if (step < 0.25) {
      return 'severe';
    } else if (step < 0.5) {
      return 'reduced';
    } else {
      return 'good';
    }
  };

  const result = {
    step: stepHealth(step),
    remaining: props.timer.remaining
  };

  return result;
});

const interval = setInterval(() => {
  const timer = props.timer;

  const { limit, remaining } = timer;
  const enabledDotCount = Math.floor((dotCount * remaining) / limit);
  const disabledDotCount = dotCount - enabledDotCount;

  // find random indexes to disable
  while (indexes.size < disabledDotCount) {
    indexes.add(Math.floor(Math.random() * dotCount));
  }
}, 2000);

watch(
  () => props.timer.remaining,
  () => {
    if (
      lastRemainingTime.value <= props.timer.remaining ||
      props.timer.remaining === 0
    ) {
      indexes.clear();
    }

    dissabledDotIndexes.value = indexes;
    dots.value = dots.value.map((dot, index) => {
      return { enabled: !indexes.has(index) };
    });

    lastRemainingTime.value = props.timer.remaining;
  }
);

onUnmounted(() => {
  clearInterval(interval);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dots.value, (dot, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["dot", {
        disabled: !dot.enabled,
        good: _unref(time).step === 'good' && dot.enabled,
        reduced: _unref(time).step === 'reduced' && dot.enabled,
        expired:
          _unref(time).step === 'expired' || (_unref(time).step === 'severe' && dot.enabled)
      }])
      }, null, 2))
    }), 128))
  ]))
}
}

})